export default __webpack_public_path__ + "static/media/114.a8127cf4.webp";